import React from "react";
import { Button, Modal } from "flowbite-react";
import { HiOutlineExclamationCircle } from "react-icons/hi";

const DeRegisterModal = ({
  visible,
  onClose,
  meterOwnership,
  onProceed,
  loading,
}) => {
  return (
    <Modal
      show={visible}
      dismissible={!loading}
      size="md"
      onClose={onClose}
      popup
    >
      <Modal.Header />
      <Modal.Body>
        <div className="text-center">
          <HiOutlineExclamationCircle
            color="red"
            className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200"
          />
          <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
            Are you sure you want to de-register this meter?
            <br />
            {meterOwnership?.meter?.number}
          </h3>
          <p className="text-center text-sm text-black my-4">
            if you proceed, you'll lose your water balance and you'll no longer
            be able to make purchases for this meter
          </p>
          <div className="flex justify-center gap-4">
            <Button
              isProcessing={loading}
              color="red"
              className="!bg-[red] !text-white"
              onClick={() => onProceed(meterOwnership)}
            >
              {"Yes, I'm sure"}
            </Button>
            <Button color="gray" onClick={onClose}>
              No, cancel
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeRegisterModal;
